import Create from './Create'
import Edit from './Edit'
import View from './View'

export default {
  Create,
  Edit,
  View
}
